import React, { useEffect, useState } from "react";
import GridLayout from "react-grid-layout";
import useElementDimensions from "../../../hooks/useElementDimensions";
import IconPreview from "../../BuilderComponents/Preview/IconPreview";
import RenderFields from "./RenderFields";
import { hasOwn } from "../../../commonFunctions/arrayFunc";
import { generateObjectId } from "../../../utils/objectIdUtils";

const DropLayout = ({
  layout,
  setLayout,
  layoutData,
  nestedGridData,
  dragFromOutside,
  setDragFromOutside,
  onDrop,
  editElement
}) => {
  return (
    <>
      <NestedLayout
        layout={layout}
        setLayout={setLayout}
        layoutData={layoutData}
        nestedGridData={nestedGridData}
        onDrop={onDrop}
        dragFromOutside={dragFromOutside}
        editElement={editElement}
        setDragFromOutside={setDragFromOutside}
      />
    </>
  );
};

export default DropLayout;

const NestedLayout = ({
  layout,
  setLayout,
  layoutData,
  nestedGridData,
  itemId,
  onDrop,
  dragFromOutside,
  editElement,
  setDragFromOutside
}) => {
  const [sectionLayout, setSectionLayout] = useState([]);
  const [selectedTabID, setselectedTabID] = useState("");
  const [{ width: elementWidth }, elementRef] = useElementDimensions();

  const handleOnDrop = (elemParams, item, e) => {
    const newItem = onDrop(elemParams, item, e, itemId, selectedTabID);
    if (!newItem) return;
    if (itemId) {
      const newNestedGridData = JSON.parse(JSON.stringify(nestedGridData.current));
      if (layoutData.current[itemId].type === "tabview") {
        newNestedGridData[selectedTabID] = [...newNestedGridData[selectedTabID], newItem];
        nestedGridData.current = newNestedGridData;
        item.h = 3;
      } else {
        newNestedGridData[itemId] = [...newNestedGridData[itemId], newItem];
        nestedGridData.current = newNestedGridData;
      }
    }
    if (itemId) {
      setSectionLayout([newItem, ...sectionLayout]);
    } else {
      setSectionLayout([newItem, ...sectionLayout]);
      setLayout([newItem, ...sectionLayout]);
    }
  };

  const changeTab = (id) => {
    setselectedTabID(id);
    setSectionLayout(nestedGridData.current[id]);
  };

  const generateRandomId = () => {
    return Math.random().toString(36).substr(2, 9);
  };

  const copyElement = (itemId) => {
    const existingElement = layoutData.current[itemId];

    if (!existingElement) {
      return;
    }

    const newElementId = `${existingElement.id}${generateRandomId()}`;
    const newElement = {
      ...existingElement,
      id: newElementId,
      name: `${existingElement.name}`
    };

    layoutData.current[newElementId] = newElement;

    setLayout((prevLayout) => {
      const copiedElement = prevLayout.find((item) => item.i === itemId);
      if (!copiedElement) {
        return prevLayout;
      }

      const updatedLayout = [...prevLayout, { ...copiedElement, i: newElementId }];

      return updatedLayout;
    });
  };

  const deleteNestedElement = (id) => {
    const newlayout = JSON.parse(JSON.stringify(layoutData.current));
    delete newlayout[id];
    layoutData.current = newlayout;
    if (itemId) {
      const newArray = sectionLayout.filter((item) => item.i !== id);
      const newNestedGridData = JSON.parse(JSON.stringify(nestedGridData.current));
      if (layoutData.current[itemId].type === "tabview") {
        newNestedGridData[selectedTabID] = newArray;
        nestedGridData.current = newNestedGridData;
      } else if (layoutData.current[itemId].type === "section") {
        newNestedGridData[itemId] = newArray;
        nestedGridData.current = newNestedGridData;
      }
      setSectionLayout(newArray);
    } else {
      const newArray = layout.filter((item) => item.i !== id);
      if (hasOwn(nestedGridData.current, id)) {
        delete nestedGridData.current[id];
      }
      setLayout(newArray);
    }
  };
  const handleLayoutChange = (list) => {
    if (dragFromOutside) return;
    if (itemId) {
      let newNestedGridData = JSON.parse(JSON.stringify(nestedGridData.current));
      if (layoutData.current[itemId].type === "tabview") {
        newNestedGridData[selectedTabID] = list;
      }
      newNestedGridData[itemId] = list;
      nestedGridData.current = newNestedGridData;
      setSectionLayout(list);
    } else {
      setSectionLayout(list);
      setLayout(list);
    }
  };

  useEffect(() => {
    if (itemId) {
      if (layoutData.current[itemId].type === "tabview") {
        setselectedTabID(layoutData.current[itemId].config.headerData[0].id);
        setSectionLayout(nestedGridData.current[layoutData.current[itemId].config.headerData[0].id]);
      } else {
        setSectionLayout(nestedGridData.current[itemId]);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (!itemId) {
      setSectionLayout(layout);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [layout]);
  return (
    <div className="detailsView_inside_page p_0">
      {layoutData.current[itemId]?.type === "tabview" && (
        <div className={`tabView_container `}>
          <div className="d_flex">
            {layoutData.current[itemId].config.headerData.map((tab) => (
              <div
                key={tab.id}
                className="tabView_items"
                style={{ borderBottom: tab.id === selectedTabID ? "1px solid #4a1fb8" : "" }}
              >
                <span className="tab_header" onClick={() => changeTab(tab.id)}>
                  {tab?.icon && <IconPreview icon={tab.icon || ""} />}
                  {tab.display}
                </span>
              </div>
            ))}
          </div>
        </div>
      )}
      <div ref={elementRef}></div>
      <GridLayout
        rowHeight={80}
        cols={12}
        width={elementWidth}
        layout={sectionLayout}
        onDrop={(elemParams, item, e) => handleOnDrop(elemParams, item, e)}
        compactType={"vertical"}
        isDroppable={true}
        droppingItem={{ i: generateObjectId(), h: 1, w: 12 }}
        useCSSTransforms={true}
        onLayoutChange={handleLayoutChange}
        className="draggable_elements_outer h_100"
        onDragStart={(layout, oldItem, newItem, _, e) => e.stopPropagation()}
        margin={[5, 5]}
      >
        {sectionLayout.map((item) => {
          return (
            <div title={layoutData.current[item.i]?.type} key={item.i}>
              <RenderFields
                item={item}
                layoutData={layoutData}
                layout={sectionLayout}
                setLayout={setSectionLayout}
                dragFromOutside={dragFromOutside}
                setDragFromOutside={setDragFromOutside}
                nestedGridData={nestedGridData}
                editElement={editElement}
                deleteElement={deleteNestedElement}
                copyElement={copyElement}
                onDrop={onDrop}
              />
            </div>
          );
        })}
      </GridLayout>
    </div>
  );
};
export { NestedLayout };
